import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

interface JobActionMenuProps {
  jobId: string;
  anchorEl: HTMLElement;
  handleClose: () => void;
  handleDelete: () => void;
}

const JobActionMenu: React.FC<JobActionMenuProps> = (
  {
    jobId, anchorEl, handleClose, handleDelete,
  },
) => {
  const navigate = useNavigate();

  const handleEditClicked = () => {
    navigate(`/job/?jobId=${jobId}`);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={handleClose}
    >
      <MenuItem id="edit-job-button" onClick={handleEditClicked}>{'Edit'}</MenuItem>
      <MenuItem id="delete-job-button" onClick={handleDelete}>{'Delete'}</MenuItem>
    </Menu>
  );
};
export default JobActionMenu;
